import React, { useState } from 'react';
import { Fade } from 'react-reveal';
import MrHandler from '../../img/mrhandy.JPG'
import Haldi from '../../img/Haldi-Wearings.png'
import GetRide from '../../img/get-ride.png'
import CountryInfo from '../../img/Country-Info.png'
import Football from '../../img/Football-Tournament.png'
import Champion from '../../img/Be-Champion.png'
import Ecommerce from '../../img/Responsive-Ecommerce.png'

import ProjectCard from './ProjectCard';
import './MyProject.css'
const MyProjects = () => {
    // const [projects, setProjects] = useState({})
    const projects = [
        {
            id: 1,
            title: 'Mr Handy Full-Stack',
            category: 'full-stack',
            uses: 'react,bootstrap, react-router, node, express, mongoDb, firebase, ect',
            img: MrHandler,
            link: 'https://mrhandy-5161.web.app/'
        },
        {
            id: 2,
            title: 'Full Ecommerce',
            category: 'wordpress',
            uses: 'wordpress, elementor, woocommerce, etc',
            img: Haldi,
            link: 'https://haldiwearings.com/'
        },
        {
            id: 3,
            title: 'Get Ride React',
            category: 'react',
            uses: 'react, bootstrap, react-router, firebase, etc',
            img: GetRide,
            link: 'https://get-ride-assignment.web.app/'
        },
        {
            id: 4,
            title: 'Country info React',
            category: 'react',
            uses: 'react, bootstrap, react-router, API, etc',
            img: CountryInfo,
            link: 'https://shakil-ahmed-country-info.netlify.app/'
        },
        {
            id: 5,
            title: 'Be-Champion React',
            category: 'react',
            uses: 'react, bootstrap, react-router, API, etc',
            img: Champion,
            link: 'https://hardcore-lichterman-ce8189.netlify.app/'
        },
        {
            id: 6,
            title: 'Football-Tournament React',
            category: 'html-css',
            uses: 'html, css, bootstrap, fake data, etc',
            img: Football,
            link: 'https://zen-mayer-46e4e3.netlify.app/'
        },
        {
            id: 7,
            title: 'Responsive-Ecommerce Template',
            category: 'html-css',
            uses: 'html, css, bootstrap, etc',
            img: Ecommerce,
            link: 'https://shakil5161.github.io/buy-or-bye/'
        },
        

    ]
    return (
        <Fade bottom duration={1000} distance="20px">
            <div className="main" id="projects">
                <h1 className="experience-heading">My Projects</h1>
                <div className="row">
                    {
                        projects.map(project => <ProjectCard project={project}></ProjectCard>)
                    }
                </div>
            </div>
        </Fade>
    );
};

export default MyProjects;